import React, { useRef } from 'react';
import ProductCard from './ProductCard';
import { motion } from 'framer-motion';
import './HomeCarousel.css';

const HomeCarousel = React.memo(function HomeCarousel({ products, title }) {
  const containerRef = useRef(null);

  // Removed unused helpers to satisfy CI linting

  return (
    <div className="home-carousel-wrapper">
      <div className="home-carousel-container home-page-carousel" ref={containerRef}>
        <div className="home-carousel-track" style={{ transform: 'translateX(0)' }}>
          {products.map((product, index) => (
            <motion.div 
              key={product._id} 
              className="home-carousel-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ 
                duration: 0.4, 
                delay: index * 0.05,
                ease: [0.4, 0, 0.2, 1]
              }}
            >
              <ProductCard product={product} large showQuickAdd={true} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default HomeCarousel;
